/**
 * Tiny "recently viewed" stack persisted to localStorage.
 *
 * Used by the Dashboard widget (R2) and the Cmd+K palette (R1) so a user
 * can resume whatever they were last touching.
 */
const KEY = "hv_recents_v1";
const MAX = 8;

function read() {
  try {
    const s = localStorage.getItem(KEY);
    if (!s) return [];
    return JSON.parse(s);
  } catch (_) {
    return [];
  }
}

function write(arr) {
  try {
    localStorage.setItem(KEY, JSON.stringify(arr.slice(0, MAX)));
  } catch (_) {
    /* ignore quota errors */
  }
}

/**
 * Push a "viewed" record. Idempotent — duplicate kind+id collapses to a
 * single freshest entry.
 *
 * @param {Object} r
 * @param {"customer"|"jobcard"|"ticket"|"lead"|"task"} r.kind
 * @param {string} r.id
 * @param {string} r.label   visible name
 * @param {string=} r.sub    optional secondary text (e.g. "ELIX001" / "JC0379")
 */
export function pushRecent(r) {
  if (!r?.id || !r?.kind || !r?.label) return;
  const arr = read().filter((x) => !(x.kind === r.kind && x.id === r.id));
  arr.unshift({ ...r, ts: Date.now() });
  write(arr);
  // Notify any listeners (e.g. dashboard widget) so they can rerender live.
  window.dispatchEvent(new Event("hv:recents:update"));
}

export function getRecents() {
  return read();
}

export function clearRecents() {
  localStorage.removeItem(KEY);
  window.dispatchEvent(new Event("hv:recents:update"));
}
